export default __webpack_public_path__ + "static/AGaramondPro-Regular-f21eb3a1c6cfc260e3f66f45df7e166b.woff";